import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'

import { fetchRest } from '@/lib/hook/tanstackQuery'

export const categoriesQueryKey = ['categories', 'all'] as const

/**
 * Reproduit la pagination du resolver getCategories (boucle while sur
 * categories?items_per_page=10000&page=N).
 */
export const fetchAllCategories = async (
  locale?: string,
  baseUrl?: string
): Promise<any[]> => {
  const results: any[] = []
  let nbPages = 1
  let page = 1
  while (page <= nbPages) {
    const pageResult = await fetchRest<any>({
      endpoint: 'categories',
      queriesParams: { items_per_page: 10000, page },
      locale,
      baseUrl,
    })
    nbPages = Math.ceil(
      parseInt(pageResult.params.total_items) / parseInt(pageResult.params.items_per_page)
    )
    results.push(...pageResult.categories)
    page++
  }
  return results
}

const useCategories = () => {
  const router = useRouter()
  const locale = (router.query.locale as string) || 'fr'
  return useQuery({
    queryKey: categoriesQueryKey,
    queryFn: () => fetchAllCategories(locale),
    staleTime: 1000 * 60 * 10,
  })
}

export default useCategories
